import { SimpleTable } from "@/core/components/simple-table";
import { PageMainCard } from "@volca/ui/components/ui/page-components";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { usePacksSection } from "./packs-section";
import { RecipientEmptyState } from "./recipient-empty-state";
import { RecipientsHeader } from "./recipients-header";
import { SIDEBAR_VIEW } from "./sidebar-view";
import { useRecipientColumns } from "./use-recipient-columns";

export const RecipientsCard = ({ embedded }: { embedded: boolean }) => {
  const {
    previewOnly,
    error,
    recipients,
    filteredRecipients,
    detailTechnicianId,
    openDetail,
    teamIds,
    setTeamIds,
    technicianSearch,
    setTechnicianSearch,
  } = usePacksSection();
  const columns = useRecipientColumns();

  return (
    <PageMainCard>
      {/* Hidden when there's nothing to send. */}
      {recipients.length > 0 && <RecipientsHeader embedded={embedded} />}
      <Stack
        align="start"
        gap={4}
        className={cn("min-h-0 w-full flex-1 overflow-hidden", {
          "opacity-60": previewOnly,
        })}
      >
        {!error && filteredRecipients.length === 0 ? (
          <RecipientEmptyState
            hasTeamFilter={teamIds.length > 0}
            onClearTeams={() => setTeamIds([])}
            searchValue={technicianSearch}
            onClearSearch={() => setTechnicianSearch("")}
          />
        ) : (
          <SimpleTable
            label="Recipients"
            data={filteredRecipients}
            columns={columns}
            getRowId={(recipient) => recipient.technician_id}
            onRowClick={(recipient) =>
              openDetail(recipient, SIDEBAR_VIEW.preview)
            }
            selectedRowId={detailTechnicianId}
            className="h-full min-h-0 w-full min-w-0"
            tableClassName="min-w-[1080px] [&_td]:align-top"
            columnPinning={{ left: ["select"] }}
          />
        )}
      </Stack>
    </PageMainCard>
  );
};
